import { useRef } from "react";
import { Helmet } from "react-helmet";
import "../Terms/styled.scss";
import "./styled.scss";
import "../../../home.scss";

const CaliforniaHeader = () => {
  return (
    <div className="section terms_head" style={{}}>
      <div className="content_container">
        <div
          className="content terms_head"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div className="terms_head_left">
            <h1>California policy </h1>
            <h2>Brandclub Privacy Notice for California Residents</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

const collectedItems = [
  {
    title: "A. Identifiers.",
    examples:
      "A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email address, account name, Social Security number, driver’s license number, passport number, or other similar identifiers.",
    collected: "YES",
  },
  {
    title:
      "B. Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e)).",
    examples:
      "A name, signature, Social Security number, physical characteristics or description, address, telephone number, passport number, driver’s license or state identification card number, insurance policy number, education, employment, employment history, bank account number, credit card number, debit card number, or any other financial information, medical information, or health insurance information. Some personal information included in this category may overlap with other categories.",
    collected: "YES",
  },
  {
    title:
      "C. Protected classification characteristics under California or federal law.",
    examples:
      "Age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed, marital status, medical condition, physical or mental disability, sex (including gender, gender identity, gender expression, pregnancy or childbirth and related medical conditions), sexual orientation, veteran or military status, genetic information (including familial genetic information).",
    collected: "NO",
  },
  {
    title: "D. Commercial information.",
    examples:
      "Records of personal property, products or services purchased, obtained, or considered, or other purchasing or consuming histories or tendencies.",
    collected: "YES",
  },
  {
    title: "E. Biometric information.",
    examples:
      "Genetic, physiological, behavioral, and biological characteristics, or activity patterns used to extract a template or other identifier or identifying information, such as, fingerprints, faceprints, and voiceprints, iris or retina scans, keystroke, gait, or other physical patterns, and sleep, health, or exercise data.",
    collected: "NO",
  },
  {
    title: "F. Internet or other similar network activity.",
    examples:
      "Browsing history, search history, information on a consumer’s interaction with a website, application, or advertisement.",
    collected: "YES",
  },
  {
    title: "G. Geolocation data.",
    examples: "Physical location or movements.",
    collected: "YES",
  },
  {
    title: "H. Sensory data.",
    examples:
      "Audio, electronic, visual, thermal, olfactory, or similar information.",
    collected: "NO",
  },
  {
    title: "I. Professional or employment-related information.",
    examples: "Current or past job history or performance evaluations.",
    collected: "NO",
  },
  {
    title:
      "J. Non-public education information (per the Family Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99)).",
    examples:
      "Education records directly related to a student maintained by an educational institution or party acting on its behalf, such as grades, transcripts, class lists, student schedules, student identification codes, student financial information, or student disciplinary records.",
    collected: "NO",
  },
  {
    title: "K. Inferences drawn from other personal information.",
    examples:
      "Profile reflecting a person’s preferences, characteristics, psychological trends, predispositions, behavior, attitudes, intelligence, abilities, and aptitudes.",
    collected: "NO",
  },
];

const CollectedItem = ({ title, examples, collected }: any) => {
  return (
    <div className="terms_grid">
      <div className="title">
        <p>{title}</p>
      </div>
      <div className="examples">
        <p>{examples}</p>
      </div>
      <div className="option">
        <p>{collected}</p>
      </div>
    </div>
  );
};

const CaliforniaContent = () => {
  return (
    <div className="section terms" style={{}}>
      <div className="content_container" style={{}}>
        <div className="content terms">
          <div className="terms_body">
            <br />
            <br />
            <br />
            <br />
            <p>Last Updated: September 26, 2022</p>
            <p>
              This Privacy Notice for California Residents supplements the
              information contained in Brandclub’s Privacy Policy and applies
              solely to all visitors, users, and others who reside in the State
              of California (“consumers” or “you”). We adopt this notice to
              comply with the California Consumer Privacy Act of 2018 (CCPA) and
              any terms defined in the CCPA have the same meaning when used in
              this notice.
            </p>
            <h1 className="faq_title">Information we collect</h1>
            <br></br>
            <p>
              The Brandclub application (the “App”) collects information that
              identifies, relates to, describes, references, is capable of being
              associated with, or could reasonably be linked, directly or
              indirectly, with a particular consumer or device (“personal
              information”). In particular, the App has collected the following
              categories of personal information from its consumers within the
              last 12 months:
            </p>
            <div className="terms_grid">
              <div className="title">
                <p>
                  <strong>Category</strong>
                </p>
              </div>
              <div className="examples">
                <p>
                  <strong>Examples</strong>
                </p>
              </div>
              <div className="option">
                <p>
                  <strong>Collected</strong>
                </p>
              </div>
            </div>
            {collectedItems.map((item, idx) => {
              return <CollectedItem {...item} key={idx}></CollectedItem>;
            })}
            <br />
            <br />
            <br />
            <br />
            <p>Personal information does not include:</p>
            <br />
            <ul>
              <li>
                <p>Publicly available information from government records.</p>
              </li>
              <li>
                <p>Deidentified or aggregated consumer information.</p>
              </li>
              <li>
                <p>Information excluded from the CCPA’s scope, like:</p>
                <ul>
                  <li>
                    <p>
                      health or medical information covered by the Health
                      Insurance Portability and Accountability Act of 1996
                      (HIPAA) and the California Confidentiality of Medical
                      Information Act (CMIA) or clinical trial data;
                    </p>
                  </li>
                  <li>
                    <p>
                      personal information covered by certain sector-specific
                      privacy laws, including the Fair Credit Reporting Act
                      (FRCA), the Gramm-Leach-Bliley Act (GLBA) or California
                      Financial Information Privacy Act (FIPA), and the Driver’s
                      Privacy Protection Act of 1994.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
            <br />
            <p>
              Brandclub obtains the categories of personal information listed
              above from the following categories of sources:
            </p>
            <br />
            <ul>
              <li>
                <p>
                  Directly from you. For example, from forms you complete when
                  signing up for your account or when you link your third party
                  retail account information.
                </p>
              </li>
              <li>
                <p>
                  Indirectly from you. For example, from observing your actions
                  on our App.
                </p>
              </li>
            </ul>

            <h1 className="faq_title">Use of personal information</h1>
            <br />
            <p>
              We may use or disclose the personal information we collect for one
              or more of the following business purposes:
            </p>
            <br />
            <ul>
              <li>
                <p>
                  To fulfill or meet the reason you provided the information.
                  For example, if you share your name and contact information to
                  ask a question about our products or services, we will use
                  that personal information to respond to your inquiry.
                </p>
              </li>
              <li>
                <p>
                  To provide, support, personalize, and develop our App,
                  products, and services.
                </p>
              </li>
              <li>
                <p>
                  To create, maintain, customize, and secure your account with
                  us.
                </p>
              </li>
              <li>
                <p>
                  To process your requests, purchases, transactions, and
                  payments and prevent transactional fraud.
                </p>
              </li>
              <li>
                <p>
                  To provide you with support and to respond to your inquiries,
                  including to investigate and address your concerns and monitor
                  and improve our responses.
                </p>
              </li>
              <li>
                <p>To personalize your App experience.</p>
              </li>
              <li>
                <p>
                  For testing, research, analysis, and product development,
                  including to develop and improve our App, products, and
                  services.
                </p>
              </li>
              <li>
                <p>
                  To respond to law enforcement requests and as required by
                  applicable law, court order, or governmental regulations.
                </p>
              </li>
              <li>
                <p>
                  As described to you when collecting your personal information
                  or as otherwise set forth in the CCPA.
                </p>
              </li>
            </ul>
            <br />
            <p>
              Brandclub will not collect additional categories of personal
              information or use the personal information we collected for
              materially different, unrelated, or incompatible purposes without
              providing you notice.
            </p>
            <h1 className="faq_title">Sharing personal information</h1>
            <br />
            <p>
              Brandclub may disclose your personal information to a third party
              for a business purpose. When we disclose personal information for
              a business purpose, we enter a contract that describes the purpose
              and requires the recipient to both keep that personal information
              confidential and not use it for any purpose except performing the
              contract.
            </p>
            <br />
            <p>
              We share your personal information with the following categories
              of third parties:
            </p>
            <br />
            <ul>
              <li>
                <p>Subsidiaries and affiliates.</p>
              </li>
              <li>
                <p>Contractors and service providers.</p>
              </li>
              <li>
                <p>Data aggregators.</p>
              </li>
              <li>
                <p>
                  Third parties with whom we partner to offer products and
                  services to you.
                </p>
              </li>
            </ul>
            <h1 className="faq_title">
              Disclosures of personal information for a business purpose
            </h1>
            <br />
            <p>
              In the preceding 12 months, Brandclub has disclosed the following
              categories of personal information for a business purpose to the
              parties identified above:
            </p>
            <br />
            <ul>
              <li>
                <p>Category A: Identifiers.</p>
              </li>
              <li>
                <p>
                  Category B: California Customer Records personal information
                  categories.
                </p>
              </li>
              <li>
                <p>Category D: Commercial information.</p>
              </li>
              <li>
                <p>Category F: Internet or other similar network activity.</p>
              </li>
              <li>
                <p>Category G: Geolocation data.</p>
              </li>
            </ul>
            <h1 className="faq_title">Sales of personal information</h1>
            <br />
            <p>
              In the preceding 12 months, Brandclub has sold personal
              information to our Brand Partners. When you participate in our
              rewards program, we will share the information we collect about
              you, including your historical and future browsing and purchase
              activity on retailers’ websites and your third party retail
              account profile information, including your name, email address,
              and billing and shipping address, with our participating brand
              partners.
            </p>
            <h1 className="faq_title">Your rights and choices</h1>
            <br />
            <p>
              The CCPA provides consumers (California residents) with specific
              rights regarding their personal information. This section
              describes your CCPA rights and explains how to exercise those
              rights.
            </p>
            <h1 className="faq_title">
              Access to specific information and data portability rights
            </h1>
            <br />
            <p>
              You have the right to request that Brandclub disclose certain
              information to you about our collection and use of your personal
              information over the past 12 months. Once we receive and confirm
              your verifiable consumer request (see Exercising Access, Data
              Portability, and Deletion Rights), we will disclose to you:
            </p>
            <br />
            <ul>
              <li>
                <p>
                  The categories of personal information we collected about you.
                </p>
              </li>
              <li>
                <p>
                  The categories of sources for the personal information we
                  collected about you.
                </p>
              </li>
              <li>
                <p>
                  Our business or commercial purpose for collecting or selling
                  that personal information.
                </p>
              </li>
              <li>
                <p>
                  The categories of third parties with whom we share that
                  personal information.
                </p>
              </li>
              <li>
                <p>
                  The specific pieces of personal information we collected about
                  you (also called a data portability request).
                </p>
              </li>
              <li>
                <p>
                  If we sold or disclosed your personal information for a
                  business purpose, two separate lists disclosing:
                </p>
                <ul>
                  <li>
                    <p>
                      sales, identifying the personal information categories
                      that each category of recipient purchased; and
                    </p>
                  </li>
                  <li>
                    <p>
                      disclosures for a business purpose, identifying the
                      personal information categories that each category of
                      recipient obtained.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
            <h1 className="faq_title">Deletion request rights</h1>
            <br />
            <p>
              You have the right to request that Brandclub delete any of your
              personal information that we collected from you and retained,
              subject to certain exceptions. Once we receive and confirm your
              verifiable consumer request (see Exercising Access, Data
              Portability, and Deletion Rights), we will delete (and direct our
              service providers to delete) your personal information from our
              records, unless an exception applies.
            </p>
            <br />
            <p>
              We may deny your deletion request if retaining the information is
              necessary for us or our service provider(s) to:
            </p>
            <br />
            <ul>
              <li>
                <p>
                  Complete the transaction for which we collected the personal
                  information, provide a good or service that you requested,
                  take actions reasonably anticipated within the context of our
                  ongoing business relationship with you, or otherwise perform
                  our contract with you.
                </p>
              </li>
              <li>
                <p>
                  Detect security incidents, protect against malicious,
                  deceptive, fraudulent, or illegal activity, or prosecute those
                  responsible for such activities.
                </p>
              </li>
              <li>
                <p>
                  Debug products to identify and repair errors that impair
                  existing intended functionality.
                </p>
              </li>
              <li>
                <p>
                  Exercise free speech, ensure the right of another consumer to
                  exercise their free speech rights, or exercise another right
                  provided for by law.
                </p>
              </li>
              <li>
                <p>
                  Comply with the California Electronic Communications Privacy
                  Act (Cal. Penal Code § 1546 et. seq.).
                </p>
              </li>
              <li>
                <p>
                  Engage in public or peer-reviewed scientific, historical, or
                  statistical research in the public interest that adheres to
                  all other applicable ethics and privacy laws, when the
                  information’s deletion may likely render impossible or
                  seriously impair the research’s achievement, if you previously
                  provided informed consent.
                </p>
              </li>
              <li>
                <p>
                  Enable solely internal uses that are reasonably aligned with
                  consumer expectations based on your relationship with us.
                </p>
              </li>
              <li>
                <p>Comply with a legal obligation.</p>
              </li>
              <li>
                <p>
                  Make other internal and lawful uses of that information that
                  are compatible with the context in which you provided it.
                </p>
              </li>
            </ul>
            <h1 className="faq_title">
              Exercising access, data portability, and deletion rights
            </h1>
            <br />
            <p>
              To exercise the access, data portability, and deletion rights
              described above, please submit a verifiable consumer request to us
              by contacting us at:
            </p>
            <br />
            <p>Brandclub, LLC or support@brandclub.com</p>
            <p>Attn: Brandclub Privacy</p>
            <p>801 5th Ave, Suite 2800</p>
            <p>Seattle, WA 98104</p>
            <br />
            <p>
              Only you, or a person registered with the California Secretary of
              State that you authorize to act on your behalf, may make a
              verifiable consumer request related to your personal information.
              You may also make a verifiable consumer request on behalf of your
              minor child.
            </p>
            <br />
            <p>
              You may only make a verifiable consumer request for access or data
              portability twice within a 12-month period. The verifiable
              consumer request must:
            </p>
            <br />
            <ul>
              <li>
                <p>
                  Provide sufficient information that allows us to reasonably
                  verify you are the person about whom we collected personal
                  information or an authorized representative.
                </p>
              </li>
              <li>
                <p>
                  Describe your request with sufficient detail that allows us to
                  properly understand, evaluate, and respond to it.
                </p>
              </li>
            </ul>
            <br />
            <p>
              We cannot respond to your request or provide you with personal
              information if we cannot verify your identity or authority to make
              the request and confirm the personal information relates to you.
            </p>
            <br />
            <p>
              Making a verifiable consumer request does not require you to
              create an account with us. We will only use personal information
              provided in a verifiable consumer request to verify the
              requestor’s identity or authority to make the request.
            </p>
            <h1 className="faq_title">Response timing and format</h1>
            <br />
            <p>
              We endeavor to respond to a verifiable consumer request within
              forty-five (45) days of its receipt. If we require more time (up
              to 90 days), we will inform you of the reason and extension period
              in writing.
            </p>
            <br />
            <p>
              If you have an account with us, we will deliver our written
              response to that account. If you do not have an account with us,
              we will deliver our written response by mail or electronically, at
              your option.
            </p>
            <br />
            <p>
              Any disclosures we provide will only cover the 12-month period
              preceding the verifiable consumer request’s receipt. The response
              we provide will also explain the reasons we cannot comply with a
              request, if applicable. For data portability requests, we will
              select a format to provide your personal information that is
              readily useable and should allow you to transmit the information
              from one entity to another entity without hindrance.
            </p>
            <br />
            <p>
              We do not charge a fee to process or respond to your verifiable
              consumer request unless it is excessive, repetitive, or manifestly
              unfounded. If we determine that the request warrants a fee, we
              will tell you why we made that decision and provide you with a
              cost estimate before completing your request.
            </p>
            <h1 className="faq_title">
              Personal information sales opt-out and opt-in rights
            </h1>
            <br />
            <p>
              If you are 16 years of age or older, you have the right to direct
              us to not sell your personal information at any time (the “right
              to opt-out”). We do not sell the personal information of consumers
              we actually know are less than 16 years of age, unless we receive
              affirmative authorization (the “right to opt-in”) from either the
              consumer who is between 13 and 16 years of age, or the parent or
              guardian of a consumer who is between 13 and 16 years of age.
              Consumers who opt-in to personal information sales may opt-out of
              future sales at any time.
            </p>
            <h1 className="faq_title">Non-discrimination</h1>
            <br />
            <p>
              We will not discriminate against you for exercising any of your
              CCPA rights. Unless permitted by the CCPA, we will not:
            </p>
            <br />
            <ul>
              <li>
                <p>Deny you goods or services.</p>
              </li>
              <li>
                <p>
                  Charge you different prices or rates for goods or services,
                  including through granting discounts or other benefits, or
                  imposing penalties.
                </p>
              </li>
              <li>
                <p>
                  Provide you a different level or quality of goods or services.
                </p>
              </li>
              <li>
                <p>
                  Suggest that you may receive a different price or rate for
                  goods or services or a different level or quality of goods or
                  services.
                </p>
              </li>
            </ul>
            <br />
            <p>
              However, we may offer you certain financial incentives permitted
              by the CCPA that can result in different prices, rates, or quality
              levels. Any CCPA-permitted financial incentive we offer will
              reasonably relate to your personal information’s value and contain
              written terms that describe the program’s material aspects.
              Participation in a financial incentive program requires your prior
              opt-in consent, which you may revoke at any time.
            </p>
            <h1 className="faq_title">Other California privacy rights</h1>
            <br />
            <p>
              California’s “Shine the Light” law (Civil Code Section § 1798.83)
              permits users of our App that are California residents to request
              certain information regarding our disclosure of personal
              information to third parties for their direct marketing purposes.
              To make such a request, please write or email to us at:
            </p>
            <br />
            <p>Brandclub, LLC or support@brandclub.com</p>
            <p>Attn: Brandclub Privacy</p>
            <p>801 5th Ave, Suite 2800</p>
            <p>Seattle, WA 98104</p>

            <h1 className="faq_title">Changes to our Privacy Notice</h1>
            <br />
            <p>
              Brandclub reserves the right to amend this privacy notice at our
              discretion and at any time. When we make changes to this privacy
              notice, we will post the updated notice on the App and update the
              notice’s effective date. Your continued use of our App following
              the posting of changes constitutes your acceptance of such
              changes.
            </p>
            <h1 className="faq_title">Contact information</h1>
            <br />
            <p>
              If you have any questions or comments about this notice, the ways
              in which Brandclub collects and uses your information described
              below and in the Privacy Policy, your choices and rights regarding
              such use, or wish to exercise your rights under California law,
              please do not hesitate to contact us at:
            </p>
            <br />
            <p>Brandclub, LLC or support@brandclub.com</p>
            <p>Attn: Brandclub Privacy</p>
            <p>801 5th Ave, Suite 2800</p>
            <p>Seattle, WA 98104</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const California = () => {
  const ref = useRef(undefined) as any;
  const disable = false;
  if (disable) {
    return <></>;
  }
  return (
    <div className="site" ref={ref}>
      <Helmet>
        <title>California Policy</title>
        <meta
          name="description"
          content="Brandclub Privacy Notice for California Residents"
        />
      </Helmet>
      <CaliforniaHeader />
      <CaliforniaContent />
    </div>
  );
};
export default California;
